<script>
import axios from "axios";
import {ref, watch} from "vue";
import {usePaySectionStore} from "@/stores/PaySection";
import useSharedData from "@/use/SharedData";
import useXLSXHeaderReference from "@/views/ImportModel/use/XLSXHeaderReference";

export default {
    props: {
        modelId: Number,
        file: [Object, File],
    },
    setup(props) {
        const {loading} = useSharedData();

        const importModel = ref({settings: []});
        const xlsxContent = ref([]);

        const {headers, address, headerExample} = useXLSXHeaderReference();

        const paySectionStore = usePaySectionStore();

        function translateCode(code) {
            const matchingPaySection = paySectionStore.paySections.find(element => element.code === code);
            return matchingPaySection ? matchingPaySection.codeLabel : code;
        }

        function findModelById(id) {
            loading.value = true;
            axios.get(`/importModels/${id}`).then((response) => {
                importModel.value = response.data;
                if (importModel.value.codeAddress) {
                    address.value[`${importModel.value.codeAddress}`] = "CODE";
                    headerExample.value[`${importModel.value.codeAddress}`] = importModel.value.realCodeLabel;
                }
                importModel.value.settings.forEach((setting) => {
                    address.value[`${setting.columnAddress}`] = setting.paySectionCode;
                    headerExample.value[`${setting.columnAddress}`] = setting.realHeader;
                });
            }).finally(() => {
                loading.value = false;
            });
        }

        function get_content() {
            const formData = new FormData();
            formData.append("file", props.file);
            axios.post("/importModels/mapXLSXContentToList", formData).then((response) => {
                xlsxContent.value = response.data;
            });
        }

        watch(() => props.modelId, () => {
            if (props.modelId) {
                findModelById(props.modelId);
            }
        });

        watch(() => props.file, () => {
            if (props.file) {
                get_content();
            } else {
                xlsxContent.value = [];
            }
        })

        return {
            importModel,
            xlsxContent,
            headers,
            headerExample,
            address,
            translateCode
        }
    }
};
</script>

<template>
    <v-row dense>
        <v-col cols="12">
            <v-simple-table dense fixed-header height="350">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-center" v-for="h in headers" :key="h">
                            <strong>
                                {{ h }}
                            </strong>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td
                            class="text-center select"
                            v-for="h in headers"
                            :key="h"
                        >
                            <strong>
                                    <span style="display: inline-block">
                                      {{ translateCode(address[`${h}`]) }}
                                    </span>
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td
                            class="text-center"
                            style="background-color: #c5e1a5"
                            v-for="h in headers"
                            :key="h"
                        >
                            <strong>
                                {{ translateCode(headerExample[`${h}`]) }}
                            </strong>
                        </td>
                    </tr>
                    <tr v-if="xlsxContent.length > 0">
                        <td :colspan="headers.length"></td>
                    </tr>
                    <tr v-for="(content, index) in xlsxContent" :key="index">
                        <td class="text-center" v-for="h in headers" :key="h">
                            <strong>
                                {{ content[`${h}`] }}
                            </strong>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<style scoped>
table tbody tr {
    height: 10px;
}

td,
th {
    white-space: nowrap;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    width: 250px;
}

.select {
    background-color: #fff3e0;
}

.select:hover {
    background-color: #80cbc4;
}
</style>